module.exports = __webpack_public_path__ + "fonts/18fff90e31885e8a7086260f606ff30b.txt";